import { useUiStateStore } from '@/@core/services/uiStateStore';
import { reactive, toRefs } from '@vue/composition-api';
import { useTimelineStore } from '../../services/store';

type TimelineModelState = {
  headers: any[];
  isLoading: boolean;
  showFormDialog: boolean;
  showDeleteDialog: boolean;
  isFormValid: boolean;
  formData: any;
  search: string;
};

const state = reactive<TimelineModelState>({
  headers: [
    {
      text: 'Nama Kegiatan',
      value: 'event'
    },
    {
      text: 'Tanggal Mulai',
      value: 'startAt'
    },
    {
      text: 'Tanggal Selesai',
      value: 'endAt'
    },
    {
      text: 'Urutan',
      value: 'order'
    },
    {
      text: '',
      value: 'actions',
      sortable: false,
      width: '1%'
    }
  ],
  isLoading: false,
  showFormDialog: false,
  showDeleteDialog: false,
  isFormValid: false,
  formData: null,
  search: ''
});

export default function useTimelineModel() {
  const store = useTimelineStore();

  const onGetManyTimeline = async () => {
    state.isLoading = true;

    try {
      state.isLoading = true;
      await store.getManyTimeline();
    } catch (err: any) {
      // useErrorMessageHandler(err)
    } finally {
      state.isLoading = false;
    }
  };

  const onCreateTimeline = async (data: any) => {
    state.isLoading = true;

    try {
      const success = await store.postTimeline(data);
      if (!success) return

      useUiStateStore().createSnackbar({
        message: `Timeline ${data.event} berhasil ditambahkan.`
      });

      state.showFormDialog = false;
      await onGetManyTimeline();
      state.formData = null;
      state.formData = {
        order: 0
      };
    } catch (err: any) {
      // useErrorMessageHandler(err)
    } finally {
      state.isLoading = false;
    }
  };

  const onUpdateTimeline = async (data: any) => {
    state.isLoading = true;

    try {
      const success = await store.putTimeline(data);
      if (!success) return
      useUiStateStore().createSnackbar({
        message: `Timeline ${data.event} berhasil diubah.`
      });
      state.showFormDialog = false;
      await onGetManyTimeline();
      state.formData = null;
      state.formData = {
        order: 0
      };
    } catch (err: any) {
      // useErrorMessageHandler(err)
    } finally {
      state.isLoading = false;
    }
  };

  const createTimeline = () => {
    state.formData = null;
    state.formData = {
      order: 0
    };
    state.showFormDialog = true;
  };

  const editTimeline = (timeline: any) => {
    state.formData = { ...timeline };
    if (timeline.startAt) state.formData.startAt = new Date(timeline.startAt).toISOString().slice(0, 10);
    if (timeline.endAt) state.formData.endAt = new Date(timeline.endAt).toISOString().slice(0, 10);

    state.showFormDialog = true;
  };

  const deleteTimeline = (timeline: any) => {
    state.formData = timeline;
    state.showDeleteDialog = true;
  };

  const onDeleteTimeline = async () => {
    state.isLoading = true;

    try {
      const success = await store.deleteTimeline(state.formData);
      if (!success) return

      const data: any = state.formData || {};
      useUiStateStore().createSnackbar({
        message: `Timeline ${data.event} berhasil dihapus.`
      });
      state.showDeleteDialog = false;
      state.formData = null;
      await onGetManyTimeline();
    } catch (err: any) {
      // useErrorMessageHandler(err)
    } finally {
      state.isLoading = false;
    }
  };

  const onSubmitForm = () => {
    const isEdit = (state.formData as any)?.id;

    if (isEdit) onUpdateTimeline(state.formData);
    else onCreateTimeline(state.formData);
  };

  return {
    ...toRefs(state),
    store,
    onGetManyTimeline,
    onSubmitForm,
    onDeleteTimeline,
    deleteTimeline,
    editTimeline,
    createTimeline
  };
}

export { useTimelineModel };
